import { render, staticRenderFns } from "./channelAttrItem.vue?vue&type=template&id=4b378c99&"
import script from "./channelAttrItem.vue?vue&type=script&lang=ts&"
export * from "./channelAttrItem.vue?vue&type=script&lang=ts&"
import style0 from "./channelAttrItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports